import { createGlobalStyle } from 'styled-components';
export const GlobalStyle = createGlobalStyle `
  body, pre, code {
    margin: 0px;
    font-family: "SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif;
    color: inherit;
  }
`;
